import React, {createRef, useContext, useState} from "react";
import {useQueryClient} from "react-query";
import moment from "moment";
import __ from "lodash";
import {makeStyles} from "@material-ui/core/styles";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  CardContent,
  Icon, CardHeader
} from "@material-ui/core";


import SystemContext from "../../../SystemContext";
import useRampActions from "../../../services/rampActions/useRampActions";
import {PushbackTug, FreighterLoading, FreighterUnloading, WaterCup} from "../../../icons";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: 'rgba(0, 0, 0, 0.54)',
    maxWidth: 24,
    minWidth: 24
  },
  cardContent: {
    marginTop: 6,
    borderRadius: 6,
    padding: "2px 2px 2px 2px",
    backgroundColor: '#f8f8fa',
  },
  cardTitle: {
    fontSize: 20,
    fontWeight:800,
    fontFamily:"Ubuntu, sans-serif",
    //fontVariantCaps: "small-caps",
    width: "100%",
    alignContent: "center",
    verticalAlign: "middle",
    marginTop: 0,
    marginLeft:-5,
    padding: 2
  },
  listItemPrimary: {
    fontSize: "medium",
    '@media (max-width: 1400px), (max-height: 2600px)' : {
      fontSize: "small",
    },
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItemSecondary: {
    fontSize: "small",
    '@media (max-width: 1400px), (max-height: 1600px)' : {
      fontSize: "x-small",
      marginTop: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  listItem: {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  listItemText: {
    marginTop: 2,
    marginBottom: 2,
  },
  '& .MuiListItem-dense': {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  '& .MuiListItemText-multiline': {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
}));
const dateTime =  "HH:mm on DD/MM/YYYY";


const FlightRampStatus = (_props) => {

  const props = {
    ..._props
  }
  const {airportCode, direction, flightNumber, aircraft, scheduledTime} = props;

  const classes = useStyles();
  const SystemData = useContext(SystemContext);

  const tableRef = createRef({state: {lastEditingRow: false}});
  const queryClient = useQueryClient();
  const extraKeys = [direction, airportCode, flightNumber, scheduledTime];
  const actions = useRampActions({tableRef, queryClient, extraKeys});

  const renderCustomIcon = (iconName) => {
    switch (iconName) {
      case "PushbackTug":
        return <PushbackTug style={{width:34, height: 34, marginLeft: "-10px"}}/>
      case "FreighterLoading":
        return <FreighterLoading style={{width:34, height: 34, marginLeft: "-10px"}}/>
      case "FreighterUnloading":
        return <FreighterUnloading style={{width:30, height: 30, marginLeft: "-10px", marginTop: "-20px"}}/>
      case "WaterCup":
        return <WaterCup style={{width:34, height: 34, marginLeft: "-6px"}}/>
      default:
        return <></>
    }
  }

  if (actions && actions.data && Array.isArray(actions.data) && actions.data.length > 0) {
    return (
      <CardContent className={classes.cardContent} style={{paddingBottom: "inherit"}}>
        <List dense={true} disablePadding={true} disableGutters={true}>
          {
            actions.data.map((action) => {
              const actionData = action.data;
              const iconName = __.has(actionData, "icon") ?  actionData.icon.replaceAll("-","_") : "";
              const hasCustomIcon = __.has(actionData, "customIcon");
              const customIcon = hasCustomIcon ? actionData.customIcon : "";

              // const iconType = __.has(actionData, "iconFamily") ? actionData.iconFamily : "";
              // const captureAdditionalValue = __.has(actionData, "additionalValue") ? actionData.additionalValue : false;
              // const additionalValueUnits = __.has(actionData, "additionalValueUnits") ? actionData.additionalValueUnits : "";
              // const additionalValue = action.quantity === 0 ? "" : action.quantity.toString();

              let subTitle;
              let statusIcon;
              let statusIconColor;
              const startAction = __.has(actionData, "startAction") && actionData.startAction;
              const endAction = __.has(actionData, "endAction") && actionData.endAction;

              if ( endAction && action.end && action.end !==""){
                subTitle = `Completed at ${moment(action.end).format(dateTime)}`;
                statusIcon = "hourglass_bottom";
                statusIconColor = "green";
              } else if (startAction && action.start && action.start !=="") {
                subTitle = `Started at ${moment(action.start).format(dateTime)}`;
                statusIcon = "hourglass_top";
                statusIconColor = "orange";
              } else if (action.notApplicable) {
                subTitle = "Not Applicable";
                statusIcon = "ban";
                statusIconColor = "grey";
              } else {
                subTitle = "Pending";
                statusIcon = "pending_actions";
                statusIconColor = "red";
              }
              const optionalItem = __.has(actionData, "optional") && actionData.optional;
              const allowPause = __.has(actionData, "allowPause") && actionData.allowPause;
              if (!(endAction && action.end && action.end !=="") && action.progressValue && Array.isArray(action.progressValue) && action.progressValue.length > 0) {
                const lastProgress = __.last(action.progressValue);
                subTitle = `${lastProgress.indicator} ${allowPause ? "" : "reported"} at ${moment.utc(lastProgress.timestamp).format(dateTime)}${__.has(lastProgress, "reason") && lastProgress.reason !== "" ? ` (${lastProgress.reason})`: ""}`;
                if (allowPause && lastProgress.indicator === 'Paused') {
                  statusIcon = "pause_circle_outline";
                  statusIconColor = "red";
                }
              }

              return (
                <ListItem key={action.rampActionUuid} className={classes.listItem} disablePadding dense >
                  <ListItemIcon className={classes.icon}>
                    { hasCustomIcon ? renderCustomIcon(customIcon) : <Icon>{iconName}</Icon> }
                  </ListItemIcon>
                  <ListItemText
                    className={classes.listItemText}
                    primaryTypographyProps={{className: classes.listItemPrimary, style: {color: statusIconColor}}}
                    secondaryTypographyProps={{className: classes.listItemSecondary, }}
                    primary={action.actionDescription}
                    secondary={subTitle}
                    inset
                  />
                  <ListItemIcon className={classes.icon}>
                    <Icon style={{color: statusIconColor}}>{statusIcon}</Icon>
                  </ListItemIcon>
                </ListItem>
              )
            })
          }
        </List>
      </CardContent>
    )
  }
  else
    return (
      <CardContent className={classes.cardContent} style={{paddingBottom: "inherit"}}>
        <CardHeader className={classes.cardTitle} title={"No Ramp Activity Reported"}
        />
      </CardContent>
    )
}

export default FlightRampStatus;
